module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-signin"
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading_logo),
      expression: "loading_logo"
    }],
    staticClass: "img",
    style: ({
      backgroundImage: 'url(' + _vm.loadingLogo() + ')'
    }),
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.lang == 'en' ? _vm.main_school.Name_EN : _vm.main_school.Name_AR))])]), _vm._v(" "), _c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.user,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [(_vm.show_dropdown) ? _c('el-row', {
    attrs: {
      "id": "school"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SELECTSCHOOL'),
      "prop": "school",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTSCHOOL')
    },
    on: {
      "change": _vm.selectSchool,
      "visible-change": _vm.getSchools
    },
    model: {
      value: (_vm.user.school),
      callback: function($$v) {
        _vm.$set(_vm.user, "school", $$v)
      },
      expression: "user.school"
    }
  }, _vm._l((_vm.schools), function(label, key) {
    return (key.split('_')[1] !== undefined) ? _c('el-option', {
      key: key,
      attrs: {
        "label": label.Name,
        "value": key
      }
    }) : _vm._e()
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('USERNAME'),
      "prop": "username",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }, {
        type: 'email',
        message: _vm.$t('MUSTCONTAINAVALIDEMAILADDRESS'),
        trigger: 'blur,change'
      }]
    }
  }, [_c('el-input', {
    staticClass: "form-control",
    attrs: {
      "size": "large",
      "autofocus": true
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.auth()
      }
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('PASSWORD'),
      "prop": "password",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "size": "large"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.auth()
      }
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-footer"
  }, [_c('div', {
    staticClass: "curve-down-area"
  }), _vm._v(" "), _c('div', {
    staticClass: "down-curve down-curve2"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-page-container"
  }, [_c('div', {
    staticClass: "form-signin"
  }, [_c('el-row', {
    staticClass: "submit_button"
  }, [_c('el-button', {
    staticClass: "btn-lg",
    staticStyle: {
      "margin-bottom": "10px",
      "width": "480px"
    },
    attrs: {
      "disabled": _vm.validateInput(),
      "size": "large"
    },
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('AUTHENTICATING') : _vm.$t('LOGIN'))
    },
    on: {
      "click": _vm.auth
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "color": "#4B4B4B"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.passwordReset
    }
  }, [_vm._v(_vm._s(_vm.$t('FORGOTPASSWORD')))])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7396a8df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 615
// module chunks = 1